import React from 'react';
import './TemplateCellIndicator.css';

function TemplateCellIndicator({
    templateName,
    version,
    onDetach
}) {
    return (
        <div className="template-cell-indicator">
            <div className="template-info">
                <span className="template-icon">🔧</span>
                <span className="template-name" title={templateName}>
                    Modèle: {templateName}
                </span>
                <span className="template-version">(v{version})</span>
                <span className="template-readonly-badge" title="Lecture seule - Les modifications seront appliquées automatiquement lors des mises à jour du modèle">
                    🔒 Lecture seule
                </span>
            </div>
            <div className="template-actions">
                <button
                    className="btn-template-action detach"
                    onClick={(e) => {
                        e.stopPropagation();
                        if (window.confirm('Détacher ce modèle ? Il deviendra une cellule normale éditable et ne recevra plus de mises à jour automatiques.')) {
                            onDetach();
                        }
                    }}
                    title="Détacher le modèle (convertir en cellule éditable)"
                >
                    ✂️ Détacher pour modifier
                </button>
            </div>
        </div>
    );
}

export default TemplateCellIndicator;
